import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Tecnica } from "../../types"
import { Button } from "@inmagik/magik-ui"
import { initialValuesTecnica, validationSchemaTecnica } from "./TecnicaCommon"
import { useMemo } from "react"
import FormatoForm from "./TecnicaForm"

export default function TecnicaModal({
  title,
  tecnica,
  save,
  show,
  onClose,
}: {
  title: string
  tecnica?: Tecnica
  save: (values: Tecnica, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
}) {
  const initialValues = useMemo(() => initialValuesTecnica(tecnica) as Tecnica, [tecnica])
  const validationSchema = useMemo(() => validationSchemaTecnica(), [])

  return (
    <Formik enableReinitialize initialValues={initialValues} validationSchema={validationSchema} onSubmit={save}>
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <FormatoForm col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
